import { voices } from '@/mocks/homeContent';

export default function VoicesSection() {
  return (
    <section id="voices" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            CUSTOMER VOICES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            お客様の声
            <span className="text-secondary-500 text-xl md:text-2xl align-middle ml-3">
              (掲載例)
            </span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            以下は実際のお客様アンケートではなく、サービスのイメージをお伝えするための掲載例です。
          </p>
        </div>

        <div className="mb-10 flex items-start gap-3 p-4 rounded-md bg-secondary-100 border border-secondary-200 text-secondary-900 text-xs md:text-sm">
          <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
            <i className="ri-information-2-line" />
          </span>
          <p>
            ※掲載しているコメント・お名前・地域はすべて
            <strong>サービス内容を伝えるための掲載例</strong>
            であり、実在のお客様のレビューではありません。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {voices.map((v) => (
            <div
              key={v.name}
              className="p-7 rounded-lg bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-0.5 text-primary-500">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      className="w-4 h-4 flex items-center justify-center"
                    >
                      <i className="ri-star-fill text-sm" />
                    </span>
                  ))}
                </div>
                <span className="px-2 py-1 rounded-md bg-secondary-500 text-background-50 text-[10px] font-bold tracking-wider">
                  掲載例
                </span>
              </div>
              <p className="text-foreground-800 text-sm leading-relaxed mb-6 flex-1">
                {v.comment}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold">
                  {v.initial}
                </div>
                <div className="flex-1">
                  <p className="font-bold text-foreground-950 text-sm">{v.name}</p>
                  <p className="text-foreground-500 text-xs">
                    {v.location} / {v.age}
                  </p>
                </div>
                <span className="px-2 py-1 rounded-full bg-accent-100 text-accent-800 text-[10px] font-bold whitespace-nowrap">
                  {v.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}